import { useState, useEffect } from "react";

import RoundedUserPic from "./RoundedUserPic";

import { formatCurrency } from "../utils/utils";
import { transformPatientPicture } from "../utils/patients";

import CheckBox from "../../components/CheckBox";

import "../css/CartItem.css";

export default ({
  patientCode,
  patientNameLastName,
  patientPic,
  cardType,
  total,
  selected,
  onClickCartItem,
}) => {
  const [cartTypeText, setCardTypeText] = useState("");
  const [cartTypeImg, setCardTypeImg] = useState("");

  useEffect(() => {
    let cTypeText = "";
    let cTypeImg = "";
    switch (cardType) {
      case "audifono":
        cTypeText = "Audífono";
        cTypeImg = "/images/preferenciaAudifonos.svg";
        break;
      case "lente":
        cTypeText = "Lente";
        cTypeImg = "/images/preferenciaGafasGraduadas.svg";
        break;
      case "lcontacto":
        cTypeText = "L. Contacto";
        cTypeImg = "/images/preferenciaLentillas.svg";
        break;
      case "liquido":
        cTypeText = "Líquido";
        cTypeImg = "/images/preferenciaLiquido.svg";
        break;
      case "montura":
        cTypeText = "Montura";
        cTypeImg = "/images/accommodative-blue.svg";
        break;
      case "varios":
        cTypeText = "Varios";
        cTypeImg = "/images/preferenciaVarios.svg";
        break;
      case "sol":
        cTypeText = "Sol";
        cTypeImg = "/images/preferenciaGafasDeSol.svg";
        break;
    }

    setCardTypeText(cTypeText);
    setCardTypeImg(cTypeImg);
  }, [cardType]);

  return (
    <div
      className={
        "sales-cart-item " + (selected ? " sales-cart-item-selected" : "")
      }
      onClick={onClickCartItem}
    >
      <div className="sales-cart-item-column">
        <div className="sales-cart-item-user">
          <RoundedUserPic
            width={30}
            height={30}
            img={transformPatientPicture(patientPic)}
          />
          <span>
            {patientCode} - {patientNameLastName}
          </span>
        </div>
      </div>
      <div className="sales-cart-item-column">
        <img src={cartTypeImg} />
        <span>{cartTypeText}</span>
      </div>
      <div className="sales-cart-item-column">{formatCurrency(total)}</div>
      <div className="sales-cart-item-column">
        <CheckBox
          active={selected}
          onClick={() => {}}
          onMouseEnter={() => {}}
          onMouseLeave={() => {}}
        />
      </div>
    </div>
  );
};
